import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, CheckCircle2, ExternalLink } from "lucide-react";
import { api } from "@/lib/api";

/**
 * Toont een waarschuwingsbanner als de bedrijfsgegevens onvolledig zijn voor
 * MyParcel-zendingen. Blijft onzichtbaar als alles OK is (om ruis te vermijden),
 * tenzij `showWhenOk` is gezet.
 */
export function VerzendingHealthBanner({ showWhenOk = false }) {
  const [health, setHealth] = useState(null);
  useEffect(() => {
    api.get("/instellingen/verzending/health")
      .then(({ data }) => setHealth(data))
      .catch(() => setHealth(null));
  }, []);

  if (!health) return null;
  if (health.ok && !showWhenOk) return null;

  if (health.ok) {
    return (
      <div data-testid="verzend-health-ok"
        className="flex items-start gap-3 p-3 rounded-lg border border-emerald-300/60 bg-emerald-50 text-emerald-800 text-sm">
        <CheckCircle2 className="h-5 w-5 shrink-0 mt-0.5" />
        <div>
          <div className="font-medium">Klaar voor MyParcel</div>
          <div className="text-xs opacity-80">
            Bedrijfsgegevens compleet en API-key geconfigureerd. Verzendingen kunnen worden aangemeld.
          </div>
        </div>
      </div>
    );
  }

  const problemen = [];
  if (!health.heeft_api_key) problemen.push("MyParcel API-key ontbreekt");
  if ((health.ontbreekt || []).length) problemen.push(`Bedrijfsgegevens onvolledig: ${health.ontbreekt.join(", ")}`);

  return (
    <div data-testid="verzend-health-warn"
      className="flex items-start gap-3 p-3 rounded-lg border border-amber-400/60 bg-amber-50 text-amber-900 text-sm">
      <AlertTriangle className="h-5 w-5 shrink-0 mt-0.5" />
      <div className="flex-1 min-w-0">
        <div className="font-medium">MyParcel-verzendingen werken nu niet</div>
        <ul className="text-xs mt-1 list-disc pl-4 space-y-0.5">
          {problemen.map((p) => <li key={p}>{p}</li>)}
        </ul>
        <div className="mt-2 flex gap-3 flex-wrap text-xs">
          <Link to="/instellingen/bedrijf" data-testid="verzend-health-link-bedrijf"
            className="inline-flex items-center gap-1 underline font-medium hover:text-amber-950">
            Bedrijfsgegevens aanvullen <ExternalLink className="h-3 w-3" />
          </Link>
          <Link to="/instellingen/verzending" data-testid="verzend-health-link-verzending"
            className="inline-flex items-center gap-1 underline hover:text-amber-950">
            Verzend-instellingen <ExternalLink className="h-3 w-3" />
          </Link>
        </div>
      </div>
    </div>
  );
}
